import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class EventService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	createEvent(event, callback) {
		const url = "/ecosystem/api/events";
		const body = JSON.stringify({
			event
		});
		this._restClient.exec_post(url, body, callback);
	}

	getAllEvents(callback) {
		const url = "/ecosystem/api/events";
		this._restClient.exec_get(url, callback);
	}

	getAllTemplates(callback) {
		const url = "/ecosystem/api/events/templates/all";
		this._restClient.exec_get(url, callback);
	}

	getEventById(eventId, callback) {
		const url = `/ecosystem/api/events/${eventId}`;
		this._restClient.exec_get(url, callback);
	}

	updateEvent(eventId, event, callback) {
		const url = `/ecosystem/api/events/${eventId}`;
		const body = JSON.stringify({
			event
		});
		this._restClient.exec_put(url, body, callback);
	}

	escalateEvent(template, callback) {
		const url = "/ecosystem/api/events/escalate";
		this._restClient.exec_post(url, template, callback);
	}

	enableEvent(eventId, callback) {
		const url = `/ecosystem/api/events/${eventId}/enable`;
		this._restClient.exec_get(url, callback);
	}

	mockUpdateEvent(eventId, callback) {
		const url = `/ecosystem/api/events/${eventId}/mock`;
		this._restClient.exec_put(url, callback);
	}

	deleteEvent(eventId, callback) {
		const url = `/ecosystem/api/events/${eventId}`;
		this._restClient.exec_delete(url, callback);
	}

	pinEntities(eventId, entities, callback) {
		const url = `/ecosystem/api/events/${eventId}/entities`;
		const body = JSON.stringify({
			entities
		});
		this._restClient.exec_put(url, body, callback);
	}

	unpinEntity(eventId, entityType, entityId, callback) {
		const url = `/ecosystem/api/events/${eventId}/entities/${entityType}/${entityId}`;
		this._restClient.exec_delete(url, callback);
	}
	updatePinnedEntities(entityId, entityType, feedId, added, removed, callback) {
		const url = "/ecosystem/api/events/updateEvent/updatePinnedEntities";
		const body = JSON.stringify({
			entityId,
			entityType,
			feedId,
			added,
			removed
		});
		this._restClient.exec_put(url, body, callback);
	}
	makeEventPublic(eventId, callback) {
		const url = `/ecosystem/api/events/${eventId}/public`;
		this._restClient.exec_put(url, null, callback);
	}

	shareEvent(eventId, orgIds, callback) {
		const url = `/ecosystem/api/events/${eventId}/share`;
		const body = JSON.stringify({
			orgIds
		});
		this._restClient.exec_put(url, body, callback);
	}

	addComment(eventId, message, callback) {
		const url = `/ecosystem/api/events/${eventId}/comment`;
		const body = JSON.stringify({
			message
		});
		this._restClient.exec_post(url, body, callback);
	}

	subscribeEvents(format = "full", status, type, callback) {
		const args = {
			status,
			type,
			filterType: "user-events",
			format
		};
		this._rc.subscribe("ecosystem", "/events", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}

	subscribeTemplates(format = "full", status, type, callback) {
		const args = {
			status,
			type,
			filterType: "user-templates",
			format
		};
		this._rc.subscribe("ecosystem", "/events", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}

	streamPinnedEntities(eventId, callback) {
		const args = {
			filterType: "pinned-to-event",
			eventId: eventId
		};
		this._rc.subscribe("ecosystem", "/events", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	subscribeEventPinnedItems(eventId, callback) {
		const args = {
			filterType: "event",
			eventId: eventId
		};
		return this._rc.subscribe("ecosystem", "/pinnedItems", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	subscribeEventCameras(eventId, callback) {
		const args = {
			filterType: "cameras",
			eventId: eventId
		};
		return this._rc.subscribe("ecosystem", "/eventEntities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}

	subscribeActiveEvents(inclusionGeo, callback) {
		const args = {
			filterType: "user-events",
			inclusionGeo,
			status: ["active"]
		};
		return this._rc.subscribe("ecosystem", "/events", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}

	queryPinnable(eventId, query, pageSize, callback) {
		const url = `/ecosystem/api/events/${eventId}/pinnable?query=${query}&pageSize=${pageSize}`;

		this._restClient.exec_get(url, callback);
	}

	// getEventStatistics(eventId, callback) {
	// 	const url = `/ecosystem/api/events/${eventId}/stats`;

	// 	this._restClient.exec_get(url, callback);
	// }

	streamAllEventStatistics(callback) {
		const args = {
			filterType: "all-statistics"
		};
		this._rc.subscribe("ecosystem", "/events", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	getEventsForPinningEntity(entityId, callback) {
		const url = `/ecosystem/api/events/forPinningEntity/${entityId}`;
		this._restClient.exec_get(url, callback);
	}

	// update the event's notes
	/**
	 * Upload a json file representing the event's notes
	 * @param {string || null} targetId -- optional string, target's id for attaching a file to an entity/list/etc
	 * @param {array} files -- Array of files
	 * @param {function} callback
	 */
	updateEventNotes(eventId, handle, notes, callback) {
		notes.forEach((notes) => {
			if (!notes.path) {
				notes.path = `${eventId}_notes`;
			}
		});
		const formData = new FormData();
		for (let x = 0; x < notes.length; x++) {
			const note = notes[x];
			//Encoding the notes HTML content because the img src sent as base64 is getting removed when sent through form data.
			if (note.html) {
				note.html = encodeURIComponent(note.html);
			}
			notes[x].html = note.html;
			formData.append(
				"upload",
				new Blob([JSON.stringify(notes[x])], {
					type: "application/json"
				}),
				`${notes[x].path}`
			);
		}
		if (handle) {
			formData.append("handle", handle);
		}
		formData.append("targetId", eventId);
		formData.append("notify", true);
		const url = "/_notesUpload";
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_multipartPost(url, formData, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_multipartPost(url, formData, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	deleteEventNotes(eventId, callback) {
		const url = `/ecosystem/api/deleteNotes/${eventId}`;
		if (callback) {
			this._restClient.exec_delete(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_delete(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	downloadEventNotes(handle, callback) {
		const url = `/_downloadEventNotes?handle=${handle}`;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	addProximity(eventId, proximity, callback) {
		const url = `/ecosystem/api/events/${eventId}/addProximity`;
		const body = JSON.stringify({
			proximity
		});
		this._restClient.exec_put(url, body, callback);
	}

	updateProximity(eventId, proximityId, proximity, callback) {
		const url = `/ecosystem/api/events/${eventId}/updateProximity/${proximityId}`;
		const body = JSON.stringify({
			proximity
		});
		this._restClient.exec_put(url, body, callback);
	}

	deleteProximity(eventId, proximityId, callback) {
		const url = `/ecosystem/api/events/${eventId}/deleteProximity/${proximityId}`;
		this._restClient.exec_delete(url, callback);
	}

	streamProximityEntities(contextId, feedId, geometry, radiuses, callback) {
		const args = {
			contextId,
			feedId,
			geometry,
			radiuses
		};

		return this._rc.subscribe("ecosystem", "/proximityEntities", args, (msg) => {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) callback(null, response);
			}
		});
	}

	/**
	 * generateLocationActivity
	 * generates an activity targeting event and setting geometry specified coordinates
	 * @param coordinates - float array in format [longitude,latitude]
	 * @param isPublic - if false activity will not be visible in activities widget
	 */
	generateLocationActivity(eventId, coordinates, isPublic = false, callback) {
		const url = `/ecosystem/api/events/${eventId}/locationActivity`;
		const body = JSON.stringify({
			coordinates,
			isPublic
		});
		this._restClient.exec_post(url, body, callback);
	}
}
